export default __webpack_public_path__ + "static/media/koffingModel.42d09dbf.glb";